// Module
var code = "<div id=\"massia-map-container\" style=\"height:300px\"></div>";
// Exports
module.exports = code;